/**
 * ChipDropdown.tsx
 *
 * This new Dropdown is used for the chips in the game setup screen and in-houses the basic composed dropdown which defines the span and the dropdown list around it
 * This component has no styling around it and is dependent upon the classes passed to it
 * Migrated from @reach/listbox to @radix-ui/react-select (Reach UI is unmaintained)
 */
import React from "react";

import * as Select from "@radix-ui/react-select";
import classNames from "classnames";

import { DownIconLarge } from "./icons/DownIconLarge";

export const ChipDropdown = ({
  chip,
  value,
  setValue,
  options,
  defaultLabel,
  wrapperClass = "",
  buttonClass = "",
  popoverClass = "",
}: {
  chip?: React.ReactElement;
  defaultLabel?: string;
  value: string | number;
  setValue: (value: string) => void;
  options: { id?: string | number; value: string | number; label: string }[];
  wrapperClass?: classNames.Argument;
  buttonClass?: classNames.Argument;
  popoverClass?: classNames.Argument;
}) => {
  if (!defaultLabel) {
    defaultLabel = options.find(
      (option) => value.toString() === option.value.toString(),
    )?.label;
  }

  return (
    <Select.Root value={value.toString()} onValueChange={setValue}>
      <Select.Trigger className={classNames(wrapperClass)}>
        <Select.Value asChild>
          <div>{chip}</div>
        </Select.Value>
        <Select.Icon>
          <DownIconLarge
            width={28}
            height={28}
            className={classNames(buttonClass)}
          />
        </Select.Icon>
      </Select.Trigger>
      <Select.Portal>
        <Select.Content className={classNames(popoverClass)} position="popper">
          <Select.Viewport>
            {options.map((option) => (
              <Select.Item
                key={option.value.toString()}
                value={option.value.toString()}
              >
                <Select.ItemText>{option.label}</Select.ItemText>
              </Select.Item>
            ))}
          </Select.Viewport>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
};
